import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: WeaveInfoState = {
  visible: false,
  weaveId: ''
};

export interface WeaveInfoState {
  visible: boolean,
  weaveId: string
}

export const slice = createSlice({
  name: 'weaveInfo',
  initialState: initialState,
  reducers: {
    show: (state, action: PayloadAction<string>) => {
      state.visible = true;
      state.weaveId = action.payload;
    },
    hide: (state) => {
      state.visible = false;
    }
  }
});

export default slice.reducer;
export const { show, hide } = slice.actions;
